export default "/assets/images/mila-feed-01.689ff709360aab95.mp4";